import { DeckStage, IAck, IBackendDeckDoc, IDeckPlanResponse, ISlidePlan } from "../models/pptInterfaces";

export const ASK_KURAL_PPT_TYPE = "ASK_KURAL";

const DEFAULT_DECK_TITLE = "Presentation Plan";
const DEFAULT_ACK: IAck = { code: "SUCCESS", message: null };

type DeckResponseModel = {
	data?: DeckDocument;
};

type DeckDocument = Partial<IBackendDeckDoc & IDeckPlanResponse> & {
	deck_id?: string;
	stage?: DeckStage;
	plan?: ISlidePlan[];
	title?: string;
};

const hasData = (response: unknown): response is DeckResponseModel => {
	return typeof response === "object" && response !== null && "data" in response;
};

const unwrapDeckResponse = (response: unknown): DeckDocument => {
	return (hasData(response) ? response.data : response) || {};
};

export const normalizeDeckResponse = (response: unknown): IDeckPlanResponse => {
	const deck = unwrapDeckResponse(response);
	const deckId = deck.deck_id || deck._id || "";
	const stage = deck.stage || deck.status || "PLANNING";
	const plan = deck.plan || deck.deck_plan || [];

	return {
		...deck,
		_id: deck._id || deckId,
		deck_id: deckId,
		deck_title: deck.deck_title || deck.title || DEFAULT_DECK_TITLE,
		stage,
		status: deck.status || stage,
		plan,
		deck_plan: deck.deck_plan || plan,
		ack: deck.ack || DEFAULT_ACK,
	};
};
